import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useActiveSchemaUri = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeUri = useMemo(() => searchParams.get('schemaUri'), [searchParams]);

  const setActiveUri = useCallback(
    (uri: string | null) => {
      if (uri) searchParams.set('schemaUri', uri);
      else searchParams.delete('schemaUri');
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams],
  );

  return [activeUri, setActiveUri] as const;
};
